<template>
    <div>
        <FullPageLoader :isLoading="loading"/>

        <div class="row">
            <div class="column medium-9">
                <div class="card">
                    <div class="card-content">
                        <h1 class="title">Wachtwoord aanpassen</h1>

                        <form class="log-in-form" @submit="finishAccount">
                            <p><strong>E-mailadres:</strong>&nbsp;{{ user.email }}</p>

                            <b-field label="Wachtwoord"
                                :message="getError(errors, 'password')"
                                :type="getType(errors, 'password', '')"
                            >
                                <b-input v-model="password" type="password" placeholder="******" password-reveal></b-input>
                            </b-field>

                            <b-field label="Wachtwoord bevestiging"
                                :message="getError(errors, 'password_confirmation')"
                                :type="getType(errors, 'password_confirmation', '')"
                            >
                                <b-input v-model="password_confirmation" type="password" placeholder="******" password-reveal></b-input>
                            </b-field>

                            <div class="button-wrap text-right">
                                <br>
                                <b-button type="is-success" @click="finishAccount">Wachtwoord wijzigen</b-button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formvalidationMixin from '@/mixins/formvalidationMixin.js'

export default {
    name: 'ActivateAccount',

    mixins: [formvalidationMixin],

    data () {
        return {
            loading: false,
            password: '',
            password_confirmation: '',
            errors: {}
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        }
    },

    methods: {
        finishAccount(){
            this.loading = true

            axios.post('/api/user/activate', { 'password': this.password, 'password_confirmation': this.password_confirmation}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.$buefy.toast.open({message: 'Wachtwoord succesvol gewijzigd!', type: 'is-success'})

                this.$store.dispatch('getUser')
                this.errors = {}
            }).catch((error) => {
                this.errors = {...error.response.data.errors}
            }).then(() => {
                this.loading = false
            })
        }
    }
}
</script>